import { useCallback } from 'react';

import { useImageLoader } from './useImageLoader';

export interface CroppedArea {
  width: number;
  height: number;
  x: number;
  y: number;
}

export function useCroppedImage() {
  const { loadImage } = useImageLoader();

  const cropImage = useCallback(
    async (imageSrc: string, crop: CroppedArea, targetSize: number = 200): Promise<string> => {
      const image = await loadImage(imageSrc);
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      if (!ctx) {
        throw new Error('Could not get canvas context');
      }

      canvas.width = targetSize;
      canvas.height = targetSize;

      ctx.drawImage(image, crop.x, crop.y, crop.width, crop.height, 0, 0, targetSize, targetSize);

      return canvas.toDataURL('image/png');
    },
    [loadImage]
  );

  return { cropImage };
}
